import { useState } from 'react';
import PropTypes from 'prop-types';
import { Check, Copy } from 'lucide-react';
import { notify } from '../../shared/utils/notify';

function compactUuid(value) {
    if (!value) return '-';
    const text = String(value);
    if (text.length <= 6) return text;
    return `${text.slice(0, 1)}…${text.slice(-3)}`;
}

export default function UuidCell({ value, className = '' }) {
    const [copied, setCopied] = useState(false);
    const fullValue = value ? String(value) : '';

    const onCopy = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!fullValue) return;

        try {
            await navigator.clipboard.writeText(fullValue);
            setCopied(true);
            notify.success('UUID скопирован');
            window.setTimeout(() => setCopied(false), 1200);
        } catch {
            notify.error('Не удалось скопировать UUID');
        }
    };

    return (
        <div className={`inline-flex max-w-full items-center gap-2 ${className}`}>
            <span
                className="font-mono text-xs text-zinc-700 dark:text-zinc-300"
                title={fullValue || '-'}
            >
                {compactUuid(fullValue)}
            </span>
            {fullValue && (
                <button
                    type="button"
                    onClick={onCopy}
                    title="Скопировать UUID"
                    aria-label="Скопировать UUID"
                    className="inline-flex h-6 w-6 items-center justify-center rounded-md border border-zinc-300 text-zinc-600 transition-colors hover:bg-zinc-100 dark:border-zinc-700 dark:text-zinc-300 dark:hover:bg-zinc-800"
                >
                    {copied ? <Check size={14} /> : <Copy size={14} />}
                </button>
            )}
        </div>
    );
}

UuidCell.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
};
